import { Link, useNavigate } from 'react-router-dom';
import { IconCalendar, IconCalendarEvent, IconCreditCard, IconHome, IconLogout, IconUser } from '@tabler/icons-react';
import { useAuthStore } from '@/store';
import { NavItem, NavItemDropdown, LogoHorizontal } from '@petseo/shared';
import { ProfileSelector, ProfileSelectorTrigger, ProfileSelectorDropdown, useProfileSelector } from '@/components/profile-selector';
import { useSelectedProfile } from '@/store/profileStore';

export function Header() {
  const navigate = useNavigate();
  const { logout } = useAuthStore();

  useProfileSelector();
  const selectedProfile = useSelectedProfile();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <>
      <header className="navbar navbar-expand-md d-print-none">
        <div className="container-xl">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbar-menu"
            aria-controls="navbar-menu"
            aria-expanded="false"
            aria-label="Toggle navigation">
            <span className="navbar-toggler-icon" />
          </button>
          <Link to="/dashboard" className="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pe-0 pe-md-3 py-1 my-0">
            <LogoHorizontal width={150} height={58} />
          </Link>
          <div className="navbar-nav flex-row order-md-last align-items-center">
            <ProfileSelector>
              <ProfileSelectorTrigger />
              <ProfileSelectorDropdown />
            </ProfileSelector>
          </div>
        </div>
      </header>
      <header className="navbar navbar-expand-md">
        <div className="container-xl">
          <div className="collapse navbar-collapse" id="navbar-menu">
            <ul className="navbar-nav px-3">
              <NavItem to="/dashboard" icon={<IconHome size={24} />} label="Home" />
              <NavItemDropdown
                icon={<IconUser size={24} />}
                label="Profile"
                items={[
                  { to: '/profiles', label: 'Moje profile' },
                  { to: '/profiles/add', label: 'Dodaj profil' },
                ]}
              />
              {selectedProfile?.canHandleServiceReservations && (
                <>
                  <NavItem to="/calendar" icon={<IconCalendar size={24} />} label="Kalendarz" />
                  <NavItem to="/reservations" icon={<IconCalendarEvent size={24} />} label="Rezerwacje" />
                </>
              )}
              <NavItem to="/subscription" icon={<IconCreditCard size={24} />} label="Subskrypcja" />
            </ul>
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <button className="nav-link" onClick={handleLogout}>
                  <span className="nav-link-icon d-md-none d-lg-inline-block">
                    <IconLogout size={24} />
                  </span>
                  <span className="nav-link-title"> Wyloguj </span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </header>
    </>
  );
}
